<custom-navbar barTitle="{{pageTitle}}" [showBack]="false"></custom-navbar>
<div class="common-tab-wraps">
  <mat-tab-group
    (selectedTabChange)="tabChanged($event)"
    [selectedIndex]="tabIndex"
    mat-stretch-tabs
    headerPosition="below"
    class="common-tab-group">

    <mat-tab label="BB리포트">
      <ng-template mat-tab-label>
        <mat-icon class="icon">assignment</mat-icon>
        <div class="title">리포트</div>
      </ng-template>
      <bb-report></bb-report>
    </mat-tab>

    <mat-tab label="예약">
      <ng-template mat-tab-label>
        <mat-icon class="icon">access_time</mat-icon>
        <div class="title">예약</div>
      </ng-template>
      <appointment></appointment>
    </mat-tab>

    <mat-tab *ngIf="!isIndividual()" label="운동기록">
      <ng-template mat-tab-label>
        <mat-icon class="icon">insert_chart</mat-icon>
        <div class="title">운동</div>
      </ng-template>
      <ex-chart></ex-chart>
    </mat-tab>

    <mat-tab label="검사기록">
      <ng-template mat-tab-label>
        <mat-icon class="icon">search</mat-icon>
        <div class="title">검사</div>
      </ng-template>
      <test-chart></test-chart>
    </mat-tab>

    <mat-tab label="더보기">
      <ng-template mat-tab-label>
        <mat-icon class="icon">more_horiz</mat-icon>
        <div class="title">더보기</div>
      </ng-template>
      <view-more></view-more>
    </mat-tab>
  </mat-tab-group>
</div>
